"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDBColumnType = void 0;
var AppDBColumnType;
(function (AppDBColumnType) {
    AppDBColumnType["String"] = "STRING";
    AppDBColumnType["Long"] = "LONG";
    AppDBColumnType["Decimal"] = "DECIMAL";
    AppDBColumnType["Double"] = "DOUBLE";
    AppDBColumnType["Date"] = "DATE";
    AppDBColumnType["Datetime"] = "DATETIME";
})(AppDBColumnType = exports.AppDBColumnType || (exports.AppDBColumnType = {}));
